import axios from "axios";
import { getSessionToken } from "../../utils/Auth/AuthUtils";

const API_URL = "/api/school";

// Get schools
const getSchools = async (location_id) => {
  const token = await getSessionToken();
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  const response = await axios.get(
    API_URL + "/all?location_id=" + location_id,
    config
  );
  //console.log("schools Service ", response.data);
  return response.data;
};

//Edit student
const editSchool = async (schoolData) => {
  const token = await getSessionToken();

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  const response = await axios.post(API_URL + "/update", schoolData, config);

  return response.data;
};

// Get school
const getSchool = async (schoolData) => {
  const token = await getSessionToken();

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  const response = await axios.get(API_URL, schoolData, config);

  return response.data;
};

const schoolService = {
  editSchool,
  getSchool,
  getSchools,
};

export default schoolService;
